import { render } from "./h-spinner.vue?vue&type=template&id=b181c5f8&ts=true"
import script from "./h-spinner.ts?vue&type=script&lang=ts"
export * from "./h-spinner.ts?vue&type=script&lang=ts"

import "./h-spinner.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__